import { type FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { Brand } from "../components/Brand";
import { PasswordInput } from "../components/PasswordInput";

export function LoginPage() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await signIn(email, password);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "Sign in failed");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="login-page">
      <section className="login-card">
        <Brand />
        <div className="login-card__intro">
          <h1>Sign in</h1>
        </div>
        <form onSubmit={(event) => void submit(event)} className="form-stack">
          <label>
            Email
            <input
              type="email"
              autoComplete="username"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </label>
          <div className="password-field">
            <label htmlFor="loginpage-password-1">Password</label>
            <PasswordInput
              id="loginpage-password-1"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </div>
          {error && (
            <div className="error-message" role="alert">
              {error}
            </div>
          )}
          <button type="submit" className="button button--primary" disabled={submitting}>
            {submitting ? "Signing in..." : "Sign in"}
          </button>
        </form>
        <Link to="/auth/forgot-password" className="button button--secondary">
          Forgot password?
        </Link>
        <nav className="login-card__legal" aria-label="Legal">
          <a href="/privacy.html">Privacy</a>
          <a href="/terms.html">Terms</a>
        </nav>
      </section>
      <aside className="login-page__brand-panel" aria-hidden="true">
        <div className="brand-panel__ring" />
        <p>Good food. Good people. Better follow-through.</p>
      </aside>
    </main>
  );
}
